import { UseMutationOptions } from 'react-query';

import { DeleteSocialConnectionMutation, DeleteSocialConnectionMutationVariables } from 'api';
import { useNotify, useSocialConnections } from 'hooks';

type Mutation = DeleteSocialConnectionMutation;
type MutationVariables = DeleteSocialConnectionMutationVariables;

const useDeleteSocialConnection = () => {
  const { socialAccounts, setSocialAccounts } = useSocialConnections();
  const notify = useNotify();

  const mutationOptions: UseMutationOptions<Mutation, unknown, MutationVariables> = {
    onMutate: ({ id }) => {
      const newSocialAccounts = socialAccounts.filter(item => item.id != id);
      setSocialAccounts(newSocialAccounts);
    },
    onError: () => {
      notify.mutationError();
    },
  };

  return mutationOptions;
};

export default useDeleteSocialConnection;
